export default {
      id: "arcs_kiosque-usage",
      viewBox: "0 0 550 620",
      url: "../dist/images/" + "sprite.svg#arcs_kiosque-usage",
      toString: function () {
        return this.url;
      }
    }